export enum VtmnPlayIconButtonVariantStyleEnum {
  REGULAR = 'regular',
  INVERSE = 'inverse',
}
